import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Typography } from '@mui/material';
import { DataGridTable } from '@shared/ui/data-grid-table';
import { ConfirmDialog } from '@shared/ui/molecules';
import {
  $columnsParamsAllreadyRelated,
  $allreadyRelatedTickets,
  clearAllreadyRelatedTickets,
  forceRelatedSave,
} from '../../../models/related-tickets';
import * as Styled from '../styled';

export const AllreadyRelatedTickets = () => {
  const { t } = useTranslation();
  const [columns, tableData] = useUnit([
    $columnsParamsAllreadyRelated,
    $allreadyRelatedTickets,
  ]);

  return (
    <ConfirmDialog
      title={t('ConfirmingTheAdditionOfConnection')}
      content={
        <Styled.DialogText>
          <Typography variant="body1">
            {t('SomeApplicationsAlreadyLinkedToAnotherIncidentAlert')}
          </Typography>

          <div>
            <DataGridTable
              disableRowSelectionOnClick
              density="compact"
              pagination={false}
              paginationMode="client"
              hideFooter
              columns={columns}
              rows={tableData}
            />
          </div>
        </Styled.DialogText>
      }
      isOpen={!!tableData.length}
      onClose={() => clearAllreadyRelatedTickets()}
      onConfirm={() => {
        clearAllreadyRelatedTickets();
        forceRelatedSave();
      }}
    />
  );
};
